export default __webpack_public_path__ + "static/media/poolImg.c72f2e2c.jpg";